import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t, i18n } = useTranslation();

  const logoAr = 'https://storage.readdy-site.link/project_files/adf26630-c3d0-464a-8966-30fa50c96b96/0ecdd294-9b85-4d78-a1fe-a7ff33498ad8_unqcode.png?v=000ba96ae80d3e18dbcb8d7ee4f955cf';
  const logoEn = 'https://storage.readdy-site.link/project_files/adf26630-c3d0-464a-8966-30fa50c96b96/395614d0-b776-44db-a0ca-604166a657a6_unqcode_en.png?v=a713f08a4ff2afac805150c0dca1a29a';
  const footerLogo = i18n.language === 'ar' ? logoAr : logoEn;

  const serviceLinks = [
    { labelKey: 'footer.srv1', path: '/services' },
    { labelKey: 'footer.srv2', path: '/services' },
    { labelKey: 'footer.srv3', path: '/services' },
    { labelKey: 'footer.srv4', path: '/services' },
    { labelKey: 'footer.srv5', path: '/services' },
    { labelKey: 'footer.srv6', path: '/services' },
  ];

  const companyLinks = [
    { labelKey: 'footer.lnk1', path: '/about' },
    { labelKey: 'footer.lnk2', path: '/about' },
    { labelKey: 'footer.lnk3', path: '/join' },
    { labelKey: 'footer.lnk4', path: '/revenue-sharing' },
    { labelKey: 'footer.lnk6', path: '/partnership' },
    { labelKey: 'footer.lnk5', path: '/contact' },
  ];

  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center mb-5">
              <img
                src={footerLogo}
                alt="UniqueCode Logo"
                className="h-10 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              {t('footer.brandDesc')}
            </p>
            <div className="flex gap-2.5">
              {[
                { icon: 'ri-twitter-x-line', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-linkedin-line', href: '#' },
                { icon: 'ri-youtube-line', href: '#' },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-xl bg-gray-100 hover:bg-brand-red text-gray-500 hover:text-white transition-all duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-black text-gray-900 text-sm uppercase tracking-wider mb-5">
              <a href="/services" className="hover:text-brand-red transition-colors">{t('footer.servicesTitle')}</a>
            </h4>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.labelKey}>
                  <Link
                    to={link.path}
                    className="text-gray-500 hover:text-brand-red text-sm transition-colors flex items-center gap-2 group"
                  >
                    <span className="w-0 h-0.5 bg-brand-red rounded group-hover:w-3 transition-all duration-200"></span>
                    {t(link.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-black text-gray-900 text-sm uppercase tracking-wider mb-5">{t('footer.companyTitle')}</h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.labelKey}>
                  <Link
                    to={link.path}
                    className="text-gray-500 hover:text-brand-red text-sm transition-colors flex items-center gap-2 group"
                  >
                    <span className="w-0 h-0.5 bg-brand-red rounded group-hover:w-3 transition-all duration-200"></span>
                    {t(link.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-black text-gray-900 text-sm uppercase tracking-wider mb-5">{t('footer.contactTitle')}</h4>
            <div className="space-y-4">
              <a href="mailto:Info@unqcode.com" className="flex items-start gap-3 group cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center bg-gray-100 group-hover:bg-brand-red rounded-lg transition-colors flex-shrink-0">
                  <i className="ri-mail-line text-gray-500 group-hover:text-white text-sm transition-colors"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-xs mb-0.5">{t('footer.emailLabel')}</div>
                  <div className="text-gray-700 text-sm font-medium group-hover:text-brand-red transition-colors">Info@unqcode.com</div>
                </div>
              </a>
              <a href="tel:+966552099231" className="flex items-start gap-3 group cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center bg-gray-100 group-hover:bg-brand-red rounded-lg transition-colors flex-shrink-0">
                  <i className="ri-phone-line text-gray-500 group-hover:text-white text-sm transition-colors"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-xs mb-0.5">{t('footer.phoneLabel')}</div>
                  <div className="text-gray-700 text-sm font-medium group-hover:text-brand-red transition-colors">+966 552 099 231</div>
                </div>
              </a>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0">
                  <i className="ri-earth-line text-gray-500 text-sm"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-xs mb-0.5">{t('footer.availLabel')}</div>
                  <div className="text-gray-700 text-sm font-medium">{t('footer.availValue')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-sm">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-gray-400 hover:text-brand-red text-sm transition-colors cursor-pointer">{t('footer.privacy')}</Link>
            <span className="text-gray-200">|</span>
            <Link to="/terms" className="text-gray-400 hover:text-brand-red text-sm transition-colors cursor-pointer">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
